import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=865baf88&scoped=true"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"
import style0 from "./QrCode.vue?vue&type=style&index=0&id=865baf88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865baf88",
  null
  
)

export default component.exports